import { DemoExample } from "@/components/sections/DemoSection";

// Re-export all demos from category files
export * from "./object-person-removal";
export * from "./background-editing";
export * from "./portrait-retouching";
export * from "./photo-enhancement";
export * from "./sky-editing";
export * from "./artistic-filters";
export * from "./animal-editing";
export * from "./specialized-services";

// Import for creating arrays
import {
    objectRemovalDemo,
    personRemovalDemo,
    crowdRemovalDemo,
    strangerRemovalDemo
} from "./object-person-removal";

import {
    backgroundChangeDemo,
    beagleBackgroundChangeDemo,
    backgroundBlurDemo,
    productBackgroundRemovalDemo,
    portraitBackgroundRemovalDemo
} from "./background-editing";

import {
    skinSmoothingDemo,
    teethWhiteningDemo,
    eyeEnhancementDemo,
    strayHairRemovalDemo
} from "./portrait-retouching";

import {
    photoEnhancementDemo,
    colorCorrectionDemo,
    photoRestorationDemo
} from "./photo-enhancement";

import {
    skyReplacementDemo,
    sunsetSkyDemo,
    blueSkyDemo,
    stormySkyDemo
} from "./sky-editing";

import {
    vintageEffectDemo,
    styleFilterDemo,
    specializedEditingDemo
} from "./artistic-filters";

import { animalEditingDemo } from "./animal-editing";

import {
    linkedinHeadshotDemo,
    linkedinHeadshotDemo2,
    glareRemovalDemo,
    glareRemovalDemo2,
    passportPhotoDemo,
    realEstatePhotoDemo,
    changeTextDemo,
    addDeceasedDemo,
    christmasDemo,
    removeExDemo,
    datingProfileDemo,
    fixClosedEyesDemo,
    tattooMockupDemo,
    noiseReductionDemo,
    watermarkRemovalDemo,
    motionBlurFixDemo,
    imageUpscalingDemo,
    perspectiveCorrectionDemo,
    cloneDuplicateDemo,
    imageMergeDemo,
    faceSwapDemo,
    colorizePhotosDemo,
    hairEditingDemo,
    clothingRecolorDemo,
    bodyEditingDemo,
    textLogoAdditionDemo,
    productPhotosDemo,
    screenshotCleanerDemo,
    fixAiErrorsDemo,
    faceSwapFriendsDemo
} from "./specialized-services";

// Homepage demos array
export const homepageDemos: DemoExample[] = [
    objectRemovalDemo,
    photoEnhancementDemo,
    beagleBackgroundChangeDemo,
    photoRestorationDemo
];

// All demos for showcase page
export const allDemos: DemoExample[] = [
    objectRemovalDemo,
    personRemovalDemo,
    crowdRemovalDemo,
    strangerRemovalDemo,
    backgroundChangeDemo,
    beagleBackgroundChangeDemo,
    backgroundBlurDemo,
    skinSmoothingDemo,
    teethWhiteningDemo,
    eyeEnhancementDemo,
    strayHairRemovalDemo,
    photoEnhancementDemo,
    colorCorrectionDemo,
    photoRestorationDemo,
    skyReplacementDemo,
    sunsetSkyDemo,
    blueSkyDemo,
    stormySkyDemo,
    vintageEffectDemo,
    styleFilterDemo,
    specializedEditingDemo,
    animalEditingDemo,
    linkedinHeadshotDemo,
    glareRemovalDemo,
    passportPhotoDemo,
    realEstatePhotoDemo,
    linkedinHeadshotDemo2,
    glareRemovalDemo2,
    changeTextDemo,
    addDeceasedDemo,
    christmasDemo,
    removeExDemo,
    datingProfileDemo,
    fixClosedEyesDemo,
    tattooMockupDemo,
    screenshotCleanerDemo,
    fixAiErrorsDemo
];

// Service-specific demo arrays
export const objectRemovalDemos: DemoExample[] = [
    objectRemovalDemo,
    crowdRemovalDemo,
    strangerRemovalDemo,
    personRemovalDemo
];

export const personRemovalDemos: DemoExample[] = [
    objectRemovalDemo,
    personRemovalDemo,
    crowdRemovalDemo,
    strangerRemovalDemo
];

export const backgroundChangeDemos: DemoExample[] = [
    backgroundChangeDemo,
    beagleBackgroundChangeDemo,
    animalEditingDemo,
    productBackgroundRemovalDemo
];

export const backgroundRemovalDemos: DemoExample[] = [
    backgroundChangeDemo,
    backgroundBlurDemo,
    productBackgroundRemovalDemo,
    portraitBackgroundRemovalDemo
];

export const skyReplacementDemos: DemoExample[] = [
    skyReplacementDemo,
    sunsetSkyDemo,
    blueSkyDemo,
    stormySkyDemo
];

export const portraitRetouchingDemos: DemoExample[] = [
    skinSmoothingDemo,
    teethWhiteningDemo,
    eyeEnhancementDemo,
    strayHairRemovalDemo
];

export const photoRestorationDemos: DemoExample[] = [
    photoRestorationDemo,
    colorCorrectionDemo,
    photoEnhancementDemo,
    objectRemovalDemo
];

export const animalEditingDemos: DemoExample[] = [
    animalEditingDemo,
    beagleBackgroundChangeDemo,
    strayHairRemovalDemo,
    eyeEnhancementDemo
];

export const colorCorrectionDemos: DemoExample[] = [
    colorCorrectionDemo,
    photoEnhancementDemo,
    photoRestorationDemo,
    vintageEffectDemo
];

export const imageEnhancementDemos: DemoExample[] = [
    photoEnhancementDemo,
    colorCorrectionDemo,
    photoRestorationDemo,
    noiseReductionDemo
];

export const artisticEffectsDemos: DemoExample[] = [
    skyReplacementDemo,
    vintageEffectDemo,
    styleFilterDemo,
    specializedEditingDemo
];

export const vintageEffectsDemos: DemoExample[] = [
    vintageEffectDemo,
    styleFilterDemo,
    photoRestorationDemo,
    colorizePhotosDemo
];

export const styleFilterDemos: DemoExample[] = [
    styleFilterDemo,
    vintageEffectDemo,
    specializedEditingDemo,
    skyReplacementDemo
];

export const specializedEditingDemos: DemoExample[] = [
    specializedEditingDemo,
    styleFilterDemo,
    tattooMockupDemo,
    changeTextDemo
];

export const backgroundBlurDemos: DemoExample[] = [
    backgroundBlurDemo,
    backgroundChangeDemo,
    portraitBackgroundRemovalDemo,
    productBackgroundRemovalDemo
];

export const productPhotosDemos: DemoExample[] = [
    productPhotosDemo,
    backgroundChangeDemo,
    colorCorrectionDemo,
    photoEnhancementDemo
];

// Demos for specific service pages
export const linkedinHeadshotDemos: DemoExample[] = [
    linkedinHeadshotDemo,
    linkedinHeadshotDemo2,
    backgroundChangeDemo,
    skinSmoothingDemo
];

export const passportVisaPhotoDemos: DemoExample[] = [
    passportPhotoDemo,
    backgroundChangeDemo,
    photoEnhancementDemo,
    colorCorrectionDemo
];

export const realEstateDemos: DemoExample[] = [
    {
        ...skyReplacementDemo,
        title: "Blue Sky Replacement",
        description: "Never let bad weather ruin a listing photo."
    },
    {
        ...objectRemovalDemo,
        title: "Decluttering",
        description: "Remove unwanted items for a clean, spacious look."
    },
    {
        ...colorCorrectionDemo,
        title: "Interior Brightening",
        description: "Make dark rooms look bright and airy."
    },
    photoEnhancementDemo
];

export const datingProfileDemos: DemoExample[] = [
    datingProfileDemo,
    photoEnhancementDemo,
    backgroundChangeDemo,
    skinSmoothingDemo
];

export const christmasPhotoDemos: DemoExample[] = [
    christmasDemo,
    backgroundChangeDemo,
    personRemovalDemo,
    photoRestorationDemo
];

export const tattooMockupDemos: DemoExample[] = [
    {
        ...specializedEditingDemo,
        title: "Realistic Placement",
        description: "Designs wrap naturally around muscles and curves."
    },
    {
        ...specializedEditingDemo,
        title: "Style Testing",
        description: "See how different styles look on your skin."
    },
    {
        ...objectRemovalDemo,
        title: "Cover Up Planning",
        description: "Hide old ink with new designs."
    },
    skinSmoothingDemo
];

export const fixAiPhotoErrorsDemos: DemoExample[] = [
    fixAiErrorsDemo,
    photoRestorationDemo,
    personRemovalDemo,
    objectRemovalDemo
];

export const removeGlareGlassesDemos: DemoExample[] = [
    glareRemovalDemo,
    glareRemovalDemo2,
    eyeEnhancementDemo,
    photoEnhancementDemo
];

export const fixClosedEyesDemos: DemoExample[] = [
    eyeEnhancementDemo,
    personRemovalDemo,
    photoEnhancementDemo,
    skinSmoothingDemo
];

export const addDeceasedLovedOneDemos: DemoExample[] = [
    addDeceasedDemo,
    photoRestorationDemo,
    personRemovalDemo,
    objectRemovalDemo
];

export const removeExFromPhotoDemos: DemoExample[] = [
    {
        ...personRemovalDemo,
        title: "Seamless Removal",
        description: "Watch them disappear instantly."
    },
    {
        ...strangerRemovalDemo,
        title: "Clean Backgrounds",
        description: "We rebuild the scene behind them."
    },
    crowdRemovalDemo,
    objectRemovalDemo
];

export const removeGlareDemos: DemoExample[] = [
    glareRemovalDemo,
    eyeEnhancementDemo,
    photoEnhancementDemo,
    skinSmoothingDemo
];

export const changeTextInImageDemos: DemoExample[] = [
    changeTextDemo,
    objectRemovalDemo,
    personRemovalDemo,
    backgroundChangeDemo
];

export const screenshotCleanerDemos: DemoExample[] = [
    screenshotCleanerDemo,
    objectRemovalDemo,
    personRemovalDemo,
    changeTextDemo
];

export const eyeSmileEnhancementDemos: DemoExample[] = [
    eyeEnhancementDemo,
    teethWhiteningDemo,
    skinSmoothingDemo,
    faceSwapDemo
];

export const blemishRemovalDemos: DemoExample[] = [
    personRemovalDemo,
    skinSmoothingDemo,
    teethWhiteningDemo,
    eyeEnhancementDemo
];

export const bodyEditingDemos: DemoExample[] = [
    bodyEditingDemo,
    personRemovalDemo,
    skinSmoothingDemo,
    tattooMockupDemo
];

export const noiseReductionDemos: DemoExample[] = [
    noiseReductionDemo,
    photoEnhancementDemo,
    photoRestorationDemo,
    colorCorrectionDemo
];

export const watermarkRemovalDemos: DemoExample[] = [
    watermarkRemovalDemo,
    objectRemovalDemo,
    personRemovalDemo,
    changeTextDemo
];

export const motionBlurFixDemos: DemoExample[] = [
    motionBlurFixDemo,
    photoEnhancementDemo,
    photoRestorationDemo,
    imageUpscalingDemo
];

export const imageUpscalingDemos: DemoExample[] = [
    imageUpscalingDemo,
    photoEnhancementDemo,
    photoRestorationDemo,
    motionBlurFixDemo
];

export const perspectiveCorrectionDemos: DemoExample[] = [
    perspectiveCorrectionDemo,
    photoEnhancementDemo,
    realEstatePhotoDemo,
    backgroundChangeDemo
];

export const cloneDuplicateDemos: DemoExample[] = [
    cloneDuplicateDemo,
    objectRemovalDemo,
    personRemovalDemo,
    removeExDemo
];

export const imageMergeDemos: DemoExample[] = [
    imageMergeDemo,
    addDeceasedDemo,
    backgroundChangeDemo,
    cloneDuplicateDemo
];

export const faceSwapDemos: DemoExample[] = [
    faceSwapDemo,
    faceSwapFriendsDemo,
    personRemovalDemo,
    skinSmoothingDemo
];

export const colorizePhotosDemos: DemoExample[] = [
    colorizePhotosDemo,
    photoRestorationDemo,
    vintageEffectDemo,
    photoEnhancementDemo
];

export const hairEditingDemos: DemoExample[] = [
    hairEditingDemo,
    strayHairRemovalDemo,
    skinSmoothingDemo,
    faceSwapDemo
];

export const clothingRecolorDemos: DemoExample[] = [
    clothingRecolorDemo,
    skinSmoothingDemo,
    photoEnhancementDemo,
    colorCorrectionDemo
];

export const textLogoAdditionDemos: DemoExample[] = [
    textLogoAdditionDemo,
    changeTextDemo,
    productPhotosDemo,
    watermarkRemovalDemo
];
